import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';
import type UserEntity from '../entities/UserEntity';
import type { UserState } from '../types/UserState';

const initialState: UserState = {
    list: [],
    current: null,
};

export const UserSliceName = 'user';
export const UserSlice = createSlice({
    name: UserSliceName,
    initialState,
    reducers: {
        setListUsers: (state, action: PayloadAction<UserEntity[]>) => {
            state.list = action.payload;
        },
        setCurrentUser: (state, action: PayloadAction<UserEntity | null>) => {
            state.current = action.payload;
        },
    },
});

export const { setListUsers, setCurrentUser } = UserSlice.actions;

export const UserReducer = UserSlice.reducer;
